export const SPLIT_VALUE_PLACEHOLDERS = [
  'San Francisco',
  'Denver',
  'New York',
  'London',
  'Istanbul',
  'Austin',
  'Boston',
  'Atlanta',
  'Seattle',
  'New Orleans',
];

export const MIN_SPLIT_VALUES = 1;
export const MAX_SPLITS = 10;
